// 后面总是可以换用其他实现，比如 [visionmedia/debug](https://github.com/visionmedia/debug)
const DUMB_FUNC = () => {}
const logger = window.console || {
  error: DUMB_FUNC,
  info: DUMB_FUNC,
  log: DUMB_FUNC,
  warn: DUMB_FUNC,
  assert: DUMB_FUNC,
  clear: DUMB_FUNC,
  debug: DUMB_FUNC,
  dir: DUMB_FUNC,
  group: DUMB_FUNC,
  groupEnd: DUMB_FUNC
};
export default logger;
